export default __webpack_public_path__ + "static/media/graphic2.0fba3684.png";